import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    open: boolean;
    title: string;
    message?: string;
    error?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    onConfirm: () => void;
    onClose: () => void;
    loading?: boolean;
    confirmColor?: 'primary' | 'error' | 'warning';
}

export function ConfirmDialog({ open, title, message, error, confirmLabel, cancelLabel, onConfirm, onClose, loading, confirmColor = 'primary' }: Props) {
    const { translate } = useApp();
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            {(message || error) && (
                <DialogContent>
                    {message && <DialogContentText>{message}</DialogContentText>}
                    {error && (
                        <Alert severity="error" sx={{ mt: message ? 2 : 0 }}>
                            {error}
                        </Alert>
                    )}
                </DialogContent>
            )}
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    {cancelLabel ?? translate('common.cancel')}
                </Button>
                <Button onClick={onConfirm} color={confirmColor} variant="contained" disabled={loading} sx={{ color: 'white' }}>
                    {loading ? translate('common.pleaseWait') : (confirmLabel ?? translate('common.confirm'))}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
